import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { WebService } from '../shared/services/web.service';
import { AwsService } from '../shared/services/aws-service';
import { API } from '../shared/enums/apiNames.enum';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import cloneDeep from 'lodash/cloneDeep';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { noEmptySpacesValidator } from '../shared/validators/whitespace.validator';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';

@Component({
  selector: 'app-new-resource',
  templateUrl: './new-resource.component.html',
  styleUrls: ['./new-resource.component.css'],
})
export class NewResourceComponent implements OnInit {
  listOfOption: Array<{ label: string; value: string }> = [];
  listOfTagOptions = [];
  resourceForm: FormGroup;
  submitted: boolean = false;
  @Input() callbackFunction: (args: any) => void;
  quickViewVisible: boolean;
  @Output('hideAddResourceDrawer') hideAddResourceDrawer: EventEmitter<any> =
    new EventEmitter();
  @Input() selectedRootFolder;
  @Input() updateMode;
  @Input() rawUpdateResource;
  @Output() hideDrawer: EventEmitter<number> = new EventEmitter<number>();
  @Output() metadataEvent: EventEmitter<void> = new EventEmitter<void>();
  @Input() childFunction: () => void;
  @Output() sendFormEvent = new EventEmitter<FormGroup>();
  @Input() initialValues: any;

  @Input() url: string;
  @Input() file: string;
  @Input() filteredResourcess: any;
  

  // @Input() url: string;
  // @Input() file: string;

  fileList: any;
  metadata: any = {};
  tagList: any[];
  tagMetaData: any;
  tagFilterList: any[];
  resource_category: any = [];
  isLoading: boolean = false;
  uploadedFileUrl: any;
  resourceId: any;
  updateUploadedFileUrl: any;
  resourcesList: any;
  uploadedFileName: any;
  userSelectedNewFile: boolean;
  isChanged: boolean = false;
  isFileSelected: boolean = false;
  EmptyStringValidation = /[\S\s]+[\S]+/;
  Uploadprogress: Number = 0;
  generateThumbnailStatus: boolean = false;
  position: number = 0;
  tempData: any;
  isShareable: boolean = true;
  constructor(
    private fb: FormBuilder,
    private webapi: WebService,
    private awsService: AwsService,
    private notification: NzNotificationService,
    private modal: NzModalService
  ) {
    this.resourceForm = fb.group({
      ResourceId: [null],
      resource_name: [null, [Validators.required]],
      category_id: [null, [Validators.required]],
      File: [null],
      resource_url: [null],
      tag: [null],
      position: [1, [Validators.required]],
      document_notes: [null],
      is_shareable: [true],
      
    });
    
    this.getMetadata();

    // this.setInitialValidators();
    // this.subscribeToInputChanges();

      // Listen for changes in position field
      this.resourceForm.get('position')?.valueChanges.subscribe(value => {
        console.log('Rank value changed:', value);
        // this.resourcePosition(value);
      });
    
  }

  private subscribeToInputChanges(): void {
    this.resourceForm.get('File').valueChanges.subscribe((file) => {
      const resourceUrlControl = this.resourceForm.get('resource_url');

      if (file) {
        resourceUrlControl.clearValidators();
        resourceUrlControl.updateValueAndValidity();
        this.resourceForm.get('File').setValidators([Validators.required]);
      } else {
        this.resourceForm.get('File').clearValidators();
        this.resourceForm.get('File').updateValueAndValidity();
        resourceUrlControl.setValidators([Validators.required]);
      }
    });

    this.resourceForm.get('resource_url').valueChanges.subscribe((url) => {
      const fileControl = this.resourceForm.get('File');

      if (url) {
        fileControl.clearValidators();
        fileControl.updateValueAndValidity();
        this.resourceForm
          .get('resource_url')
          .setValidators([Validators.required]);
      } else {
        this.resourceForm.get('resource_url').clearValidators();
        this.resourceForm.get('resource_url').updateValueAndValidity();
        fileControl.setValidators([Validators.required]);
      }
    });
  }

  // sendFormToResource() {
  //   this.sendFormEvent.emit(this.resourceForm);
  // }

  ngOnInit(): void {
    const domainOnlyPattern = /^(https?:\/\/)(localhost|\d{1,3}(\.\d{1,3}){3}|([\w-]+(\.[\w-]+)+))(:\d+)?(\/[^\s]*)?$/i;
    
    if (this.file) {
      this.resourceForm.get('File').setValidators([Validators.required]);
    } else if (this.url) {
      this.resourceForm
        .get('resource_url')
        .setValidators([Validators.required, Validators.pattern(domainOnlyPattern)]);
    }

    if (this.updateMode) {
      this.resourceId = this.initialValues.resource_id;
      this.uploadedFileName = this.initialValues.resource_path;
      this.uploadedFileUrl = this.initialValues.resource_path_url;
      this.position = this.initialValues.index;
      this.isShareable = this.initialValues.is_shareable ;
      // this.uploadedFileName = this.initialValues.resource_name;
      // this.uploadedFileUrl = this.initialValues.resource_url;

      this.userSelectedNewFile = false;

      const tagIds = this.initialValues.tag.map((tag) => tag.tag_id);
      this.resourceForm.patchValue({
        resource_name: this.initialValues.resource_name,
        category_id: this.initialValues.category_id,
        resource_url: this.initialValues.resource_url,
        document_notes: this.initialValues.document_notes,
        position: this.initialValues.index,
        is_shareable: this.initialValues.is_shareable ,
      });

      this.resourceForm.controls.tag.setValue(tagIds);
      //latest
      // setTimeout(() => {
      //   this.setOriginalFormValue()
      // }, 1000);
    }
    this.setOriginalFormValue();

    this.resourceForm.get('resource_url')?.valueChanges.subscribe(value => {
      if (value && value !== value.trim()) {
        this.resourceForm.get('resource_url')?.setValue(value.trim(), { emitEvent: false });
      }
    });
  }
  confirmModal?: NzModalRef;
  showAlert(title, msg): void {
    this.confirmModal = this.modal.error({
      nzTitle: title,
      nzContent: msg,
      nzOnOk: () => {},
    });
  }
  originalFormValue: any; // Store the original form value
  checkFormState() {
    if (this.isFormNotEmpty()) {
      this.hideDrawer.emit(1);
      return;
    }
    // Close the drawer if the form is empty
    // this.visible = false;
    this.hideDrawer.emit();
  }

  // Method to set the original form value before patchValue is called
  setOriginalFormValue(): void {
    this.originalFormValue = { ...this.resourceForm.value };
  }

  // Updated hasFormChanged() method to check for value differences
  hasFormChanged(): boolean {
    if (!this.originalFormValue) {
      return false; // No original form value to compare (form not patched yet)
    }

    const formControls = this.resourceForm.controls;
    console.log("this is formControls", formControls);
    for (const controlName in formControls) {
      if (formControls.hasOwnProperty(controlName)) {
        const originalValue = this.originalFormValue[controlName];
        const currentValue = formControls[controlName].value;

        console.log("This is originalValue", originalValue);
        console.log("This is currentValue", currentValue);

        if (originalValue != currentValue) {
        console.log("inside the if condition");
          return true; // Found a difference in form values
        }
      }
    }

    return false; // No differences found in form values
  }

  isFormNotEmpty(): boolean {
    if (this.resourceForm.controls) {
      if (this.hasFormChanged()) return true;
      else return false;
    } else {
      for (const controlName in this.resourceForm.controls) {
        if (this.resourceForm.controls.hasOwnProperty(controlName)) {
          const control = this.resourceForm.get(controlName);
          if (control && control.value !== null && control.value !== '') {
            return true; // Form control has a non-empty value
          }
        }
      }
      return false; // No form control has a non-empty value
    }
    // Check if any form control has a non-empty value
  }

  formatBytes(bytes) {
    if (bytes < 1024) {
      return bytes + ' bytes';
    } else if (bytes < 1024 * 1024) {
      return (bytes / 1024).toFixed(2) + ' KB';
    } else if (bytes < 1024 * 1024 * 1024) {
      return (bytes / (1024 * 1024)).toFixed(2) + ' MB';
    } else {
      return (bytes / (1024 * 1024 * 1024)).toFixed(2) + ' GB';
    }
  }

  submitResource() {
    if (!this.resourceForm.valid) {
      this.createNotification('error', '', 'Enter valid details');
      return;
    }
  
    // this.uploadedFileUrl = environment.BUCKET_URL + this.fileList.name;

    this.isLoading = true;
    if (this.fileList) {
      this.uploadedFileUrl = environment.BUCKET_URL + this.fileList.name;
      const unixTimestamp = Date.now();
      const fileExtension = this.getFileExtension(this.fileList.name);
      const combinedFileName = `${unixTimestamp}.${fileExtension}`;
      this.awsService
        .uploadFile(this.fileList, combinedFileName, (progress) => {
          this.Uploadprogress = progress;
        })
        .then((data) => {
          let fileSize = this.fileList.size;
          let fileSizeString = this.formatBytes(fileSize);
          // let fileSizeInKB = Math.ceil(this.fileList.size / 1024);

          let obj = {
            ...this.resourceForm.value,
          };

          obj.target_index = obj.position;
          console.log("this is object", obj);
          
          if (!obj.target_index || obj.target_index < 1) {
            throw new Error("Enter valid position!");
          }
          
          this.submitted = true;
          // obj.resource_name = this.fileList.name;
          obj.size = fileSizeString;
          obj.resource_path = combinedFileName;
          //File share
          obj.is_shareable = this.isShareable;
          console.log("this is this.isShareable", this.isShareable)

        

          if (this.selectedRootFolder) {
            obj.parent_folder = this.selectedRootFolder;
          }
          else{
            obj.parent_folder = null;
          }

          //Create thumbnail & upload the file & thumbnail for PDF File
          if (['pdf'].includes(fileExtension)) {
            this.awsService
              .generateThumbnail(this.fileList)
              .then((imageData: string) => {
                console.log('Base64 Image:', imageData);
                // Use the imageData as needed
                const thumbnailBlob = this.awsService.base64ToBlob(
                  imageData,
                  'image/png'
                );

                //Now upload the thumbnail to the AWS S3
                this.awsService
                  .uploadThumbnail(thumbnailBlob, `${unixTimestamp}.png`)
                  .then((result: string) => {
                    console.log(
                      'this is result after uploaded thumbnail on s3',
                      result
                    );
                    obj.resource_thumbnail = `thumbnail/${unixTimestamp}.png`;
                    //Then save the thumbnail and File path to the backend Database
                    console.log('this is add resource obj', obj);

                    this.webapi.requestJson(API.ADDRESOURCE, obj).subscribe(
                      (data) => {
                        var response = JSON.parse(data.body);
                        this.isLoading = false;
                        // this.metadataEvent.emit();
                        console.log("this is response  new resource",response);
                        this.sendNewResourceToParent(response.data[0])
                        this.createNotification(
                          'success',
                          '',
                          response['message']
                        );
                        this.hideDrawer.emit();
                      },
                      (error) => {}
                    );
                  });
              })
              .catch((error) => {
                this.isLoading = false;
                this.createNotification(
                  'error',
                  '',
                  'Error in uploading thumbnail'
                );
                console.error('Error rendering PDF:', error);
              });
          }
          //Create thumbnail & upload the file & thumbnail for PDF File
          if (['mp4', 'avi', 'mov'].includes(fileExtension)) {
            console.log('inside the video functionality');
            this.awsService
              .generateVideoThumbnail(this.fileList)
              .then((imageData: string) => {
                console.log('Base64 Image:', imageData);
                // Use the imageData as needed
                const thumbnailBlob = this.awsService.base64ToBlob(
                  imageData,
                  'image/png'
                );

                console.log('video thumbnail blob', thumbnailBlob);

                //Now upload the thumbnail to the AWS S3
                this.awsService
                  .uploadThumbnail(thumbnailBlob, `${unixTimestamp}.png`)
                  .then((result: string) => {
                    console.log(
                      'this is result after uploaded thumbnail on s3',
                      result
                    );
                    obj.resource_thumbnail = `thumbnail/${unixTimestamp}.png`;

                    //Then save the thumbnail and File path to the backend Database
                    console.log('this is add resource obj', obj);

                    this.webapi.requestJson(API.ADDRESOURCE, obj).subscribe(
                      (data) => {
                        var response = JSON.parse(data.body);
                        this.isLoading = false;
                        // this.metadataEvent.emit();
                        console.log("this is response  new resource", response);
                        this.sendNewResourceToParent(response.data[0])
                        this.createNotification(
                          'success',
                          '',
                          response['message']
                        );
                        this.hideDrawer.emit();
                      },
                      (error) => {}
                    );
                  });
              })
              .catch((error) => {
                console.error('Error rendering PDF:', error);
              });
          }

          //Handle Image update
          if (['jpg', 'jpeg', 'png'].includes(fileExtension)) {
            console.log('inside the image upload functionality');
            //Then save the thumbnail and File path to the backend Database
            console.log('this is add resource obj', obj);
            this.webapi.requestJson(API.ADDRESOURCE, obj).subscribe(
              (data) => {
                var response = JSON.parse(data.body);
                this.isLoading = false;
                // this.metadataEvent.emit();
                console.log("this is response  new resource", response);
                this.sendNewResourceToParent(response.data[0])
                this.createNotification('success', '', response['message']);
                this.hideDrawer.emit();
              },
              (error) => {}
            );
          }
          this.Uploadprogress = 0;
        })
        .catch((error) => {
          console.log(error)
          this.isLoading = false;
          this.Uploadprogress = 0;
          this.createNotification(
            'error',
            '',
            'An error occurred. Please try again later.'
          );
        });
    } else {
      this.finalResource();
    }
  }

  finalResource() {
    let obj = {
      ...this.resourceForm.value,
    };

    
    obj.target_index = obj.position;
    console.log("this is object", obj);
    
    if (!obj.target_index || obj.target_index < 1) {
      throw new Error("Enter valid position!");
    }

    //File share
    obj.is_shareable = this.isShareable;
    console.log("this is this.isShareable", this.isShareable)
    
    //THIS IS FOR LINK UPLOAD
    console.log('This is URL obj', obj);
    //Added parentFolder key to save URL inside their respective folder
    if (this.selectedRootFolder) {
      obj.parent_folder = this.selectedRootFolder;
    }
    else{
      obj.parent_folder = null;
    }

    this.webapi.requestJson(API.ADDRESOURCE, obj).subscribe(
      (data) => {
        let response = JSON.parse(data.body);
        this.isLoading = false;
        // this.metadataEvent.emit();
        console.log("this is response  new resource", response);
        this.sendNewResourceToParent(response.data[0])
        this.createNotification('success', '', response['message']);
        this.hideDrawer.emit();
      },
      (error) => {
        this.isLoading = false;

        this.createNotification(
          'error',
          '',
          'An error occurred. Please try again later.'
        );
      }
    );
  }

  createNotification(type, title, msg): void {
    this.notification.create(type, title, msg);
  }

  selectInvalid(controls) {
    return { 'selectOption-invalid': this.submitted && controls };
  }

  onSubmit() {
    if (this.resourceForm.status === 'VALID') {
    }
  }
  // bytesToMB(bytes) {
  //   const MB = 1024 * 1024; // 1 MB = 1024 * 1024 bytes
  //   return (bytes / MB).toFixed(2); // Convert to MB and round to 2 decimal places
  // }
  beforeUpload = (file: NzUploadFile): boolean => {
    const fileType = file.type.split('/')[0]; // Get the type of file (image, pdf, video)
    const fileExtension = file.name.split('.').pop().toLowerCase(); // Get the file extension
    //pass the bytes
    // const fileSize = parseInt(this.bytesToMB(file.size));//return MB
    // console.log("file size",file.size)
    // const FILE_LIMIT = 500;//MB
    // Check if the file type is allowed
    if (
      (fileType === 'image' &&
        ['jpg', 'jpeg', 'png', 'gif'].includes(fileExtension)) || // Image files
      // (fileType === 'application' && ['pdf', 'doc', 'docx', 'xls', 'xlsx'].includes(fileExtension)) || // Document files
      (fileType === 'application' && ['pdf'].includes(fileExtension)) || // Document files
      (fileType === 'video' && ['mp4', 'avi', 'mov'].includes(fileExtension)) // Video files
      // && (fileSize <= FILE_LIMIT)
    ) {
      this.fileList = file;
      this.resourceForm.get('File').setValue(this.fileList);
      this.isFileSelected = true;

      return false; // Allow upload
    } else {
      // File type not allowed
      // if(fileSize > FILE_LIMIT){

      //   console.error(`File too large! Max size: ${FILE_LIMIT}MB`);
      //   this.showAlert(
      //     'File too large! Max size: 500MB',
      //     `Your file is ${fileSize}MB, which exceeds the maximum limit of ${FILE_LIMIT}MB. Please upload a smaller file.`
      //   );
      //   return false; // Prevent upload
      // }

      // else{
      // You can show a message to the user indicating that only image, pdf, and video files are allowed
      this.isFileSelected = false;
      console.error('Only image, pdf, and video files are allowed.');
      this.showAlert(
        'Invalid file format detected.',
        'Only PDF, image, and video files are supported. Please upload a valid file format.'
      );
      return false; // Prevent upload

      // }
    }

    this.fileList = file;
    this.resourceForm.get('File').setValue(this.fileList);
    return false;
  };

  validateForm(): void {
    Object.keys(this.resourceForm.controls).forEach((key) => {
      this.resourceForm.get(key)?.updateValueAndValidity();
    });
  }

  getMetadata(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.isLoading = true;
      this.webapi
        .requestJson('getMetaData', {
          metadata: ['resource_category', 'resource_tags', 'resource'],
        })
        .subscribe(
          (data) => {
            let response = JSON.parse(data.body);
            this.metadata = cloneDeep(response.data);
            this.resourcesList = this.metadata.resourceData;

            this.metadata = cloneDeep(response.data);
            if (this.metadata.resourceTagCategory) {
              this.tagMetaData = this.metadata.resourceTagCategory;
              this.tagList = [...this.tagMetaData];
              this.tagFilterList = [];
              this.tagList.forEach((element) => {
                this.tagFilterList.push({
                  text: element.name,
                  value: element.tag_id,
                  byDefault: false,
                });
              });
            }
            if (this.metadata.resourceCategory) {
              this.resource_category = this.metadata.resourceCategory;
            }
            this.isLoading = false;
            resolve();
          },
          (error) => {
            // this.showLoad = false;
            this.createNotification(
              'error',
              '',
              'An error occurred. Please try again later.'
            );
            var msg = error.headers.get('message');
            this.isLoading = false;
            reject();
          }
        );
    });
  }
  cancelForm() {
    this.hideAddResourceDrawer.emit();
  }
  previewFile = (file: NzUploadFile): Observable<string> => {
    return this.fileList.name;
  };

  sendFormToParent() {
    // this.sendFormEvent.emit(this.resourceForm);
  }

  sendNewResourceToParent(newResource) {
    console.log("this is event function", newResource);
    this.sendFormEvent.emit(newResource)
  }

  hideDrawerAndSendForm() {
    this.hideDrawer.emit();
    this.sendFormToParent();

  }

  getFileExtension(fileName) {
    const parts = fileName.split('.');
    const extension = parts[parts.length - 1];
    return extension.toLowerCase();
  }

  updateFile(): void {
    if (
      !this.resourceForm.get('resource_name').valid ||
      !this.resourceForm.get('category_id').valid
    ) {
      console.log(this.resourceForm);
      this.createNotification('error', '', 'Enter valid details');
      return;
    }

    this.isLoading = true;

    console.log('this is file list', this.fileList);
    console.log(
      'this is initialValues.resourcepath ',
      this.initialValues.resource_path
    );
    console.log('this is initialValue', this.initialValues);

    //Incase of new file added
    if (
      this.fileList
      // &&
      // this.initialValues.resource_path !== this.fileList.name
    ) {
      const unixTimestamp = Date.now();
      const fileExtension = this.getFileExtension(this.fileList.name);
      // const combinedFileName = this.initialValues.resource_path ? this.initialValues.resource_path :  `${unixTimestamp}.${fileExtension}`;
      const resourceNameWithoutExtension = this.initialValues.resource_path
        ? this.initialValues.resource_path.split('.')[0]
        : unixTimestamp;
      const combinedFileName = `${resourceNameWithoutExtension}.${fileExtension}`;

      const thumbnailName =
        this.initialValues.resource_thumbnail &&
        this.initialValues.resource_thumbnail.split('/')[1];
      console.log('Thumbnail name', thumbnailName);
      console.log('this is combinedFileName', combinedFileName);
      this.awsService
        .uploadFile(this.fileList, combinedFileName, (progress) => {
          this.Uploadprogress = progress;
        })
        .then((data) => {
          let fileSize = this.fileList.size;
          let fileSizeString = this.formatBytes(fileSize);

          // let fileSizeInKB = Math.ceil(this.fileList.size / 1024);
          let obj = {
            ...this.resourceForm.value,
          };
          this.submitted = true;
                
          obj.target_index = obj.position;
          console.log("this is object", obj);
          
          if(!obj.target_index || obj.target_index < 1){
            throw new Error("Enter valid position!");
          }
    

          (obj.resource_id = this.resourceId),
            // (obj.resource_name = this.fileList.name);
            (obj.size = fileSizeString);
          obj.resource_path = combinedFileName;

          if (this.selectedRootFolder || this.initialValues.parent_folder) {
            obj.parent_folder = this.selectedRootFolder ? this.selectedRootFolder : this.initialValues.parent_folder;
          }
          else{
            obj.parent_folder = null;
          }

          //Create thumbnail & upload the file & thumbnail for PDF File
          if (['pdf'].includes(fileExtension)) {
            this.awsService
              .generateThumbnail(this.fileList)
              .then((imageData: string) => {
                console.log('update Base64 Image:', imageData);
                // Use the imageData as needed
                const thumbnailBlob = this.awsService.base64ToBlob(
                  imageData,
                  'image/png'
                );
                const resourceThumbnail = thumbnailName
                  ? thumbnailName
                  : `${unixTimestamp}.png`;
                //Now upload the thumbnail to the AWS S3
                this.awsService
                  .uploadThumbnail(thumbnailBlob, resourceThumbnail)
                  .then((result: string) => {
                    console.log(
                      'updated thumbnail uploaded result on s3',
                      result
                    );
                    obj.resource_thumbnail = `thumbnail/${resourceThumbnail}`;

                    //Delete Previous File and Thumbnail from S3

                    // Write code here

                    //Then save the thumbnail and File path to the backend Database
                    console.log('this is add resource obj', obj);

                    this.webapi.requestJson('updateResource', obj).subscribe(
                      (data) => {
                        var response = JSON.parse(data.body);
                        this.isLoading = false;

                        console.log("this is response  new resource", response);
                        this.sendNewResourceToParent(response.data[0])
                        // this.metadataEvent.emit();
                        this.createNotification(
                          'success',
                          '',
                          response['message']
                        );

                        this.hideDrawer.emit();
                      },
                      (error) => {
                        this.isLoading = false;
                        this.createNotification(
                          'error',
                          '',
                          'something went wrong, please try again'
                        );
                      }
                    );
                  });
              })
              .catch((error) => {
                console.error('Error rendering PDF:', error);
              });
          }
          //Create thumbnail & upload the file & thumbnail for PDF File
          if (['mp4', 'avi', 'mov'].includes(fileExtension)) {
            console.log('inside the video functionality');
            this.awsService
              .generateVideoThumbnail(this.fileList)
              .then((imageData: string) => {
                console.log('Base64 Image:', imageData);
                // Use the imageData as needed
                const thumbnailBlob = this.awsService.base64ToBlob(
                  imageData,
                  'image/png'
                );

                console.log('video thumbnail blob', thumbnailBlob);
                const resourceThumbnail = thumbnailName
                  ? thumbnailName
                  : `${unixTimestamp}.png`;

                //Now upload the thumbnail to the AWS S3
                this.awsService
                  .uploadThumbnail(thumbnailBlob, resourceThumbnail)
                  .then((result: string) => {
                    console.log(
                      'this is result after uploaded thumbnail on s3',
                      result
                    );

                    obj.resource_thumbnail = `thumbnail/${resourceThumbnail}`;

                    //Delete Previous File and Thumbnail from S3

                    // Write code here

                    //Then save the thumbnail and File path to the backend Database
                    console.log('this is update resource obj', obj);

                    this.webapi.requestJson('updateResource', obj).subscribe(
                      (data) => {
                        var response = JSON.parse(data.body);
                        this.isLoading = false;
                        console.log("this is response  update resource", response);
                        this.sendNewResourceToParent(response.data[0])
                        // this.metadataEvent.emit();
                        this.createNotification(
                          'success',
                          '',
                          response['message']
                        );

                        this.hideDrawer.emit();
                      },
                      (error) => {
                        this.isLoading = false;
                        this.createNotification(
                          'error',
                          '',
                          'An error occurred. Please try again later.'
                        );
                      }
                    );
                  });
              })
              .catch((error) => {
                console.error('Error rendering PDF:', error);
              });
          }
          //upload image
          if (['jpg', 'png', 'jpeg'].includes(fileExtension)) {
            console.log('this is update resource obj', obj);
            this.webapi.requestJson('updateResource', obj).subscribe(
              (data) => {
                var response = JSON.parse(data.body);
                this.isLoading = false;

                console.log("this is response  update resource", response);
                this.sendNewResourceToParent(response.data[0])
                // this.metadataEvent.emit();
                this.createNotification('success', '', response['message']);

                this.hideDrawer.emit();
              },
              (error) => {
                this.isLoading = false;
                this.createNotification(
                  'error',
                  '',
                  'An error occurred. Please try again later.'
                );
              }
            );
          }
        })
        .catch((error) => {
          console.log('error', error);
          this.createNotification(
            'error',
            '',
            'An error occurred. Please try again later.'
          );
        });
    }
    //in case of no file change but other details change
    if (
      this.fileList === undefined &&
      this.initialValues.resource_path
      // this.initialValues.resource_path !== this.fileList.name
    ) {
      console.log('this is resourceform value', this.resourceForm);
      let obj = {
        ...this.resourceForm.value,
      };

      
    obj.target_index = obj.position;
    console.log("this is object", obj);
    
    if(!obj.target_index || obj.target_index < 1){
      throw new Error("Enter valid position!");
    }
    
      obj.category_id = this.resourceForm.value.category_id
        ? this.resourceForm.value.category_id
        : this.initialValues.category_id;

      obj.resource_path = this.resourceForm.value.resource_path
        ? this.resourceForm.value.resource_path
        : this.initialValues.resource_path;

      obj.resource_name = this.resourceForm.value.resource_name
        ? this.resourceForm.value.resource_name
        : this.initialValues.resource_name;

      obj.document_notes = this.resourceForm.value.document_notes
        ? this.resourceForm.value.document_notes
        : this.initialValues.document_notes;
      obj.size = this.initialValues.size && this.initialValues.size;
      console.log('This is this.initialValues value', this.initialValues);

      // obj.resource_thumbnail = this.initialValues.resource_thumbnail;

      obj.resource_id = this.resourceId;
      if (this.selectedRootFolder || this.initialValues.parent_folder) {
        obj.parent_folder = this.selectedRootFolder ? this.selectedRootFolder : this.initialValues.parent_folder;
      
      }
      else{
        obj.parent_folder = null;
      }
      console.log('this is obj for update file==>', obj);

      this.webapi.requestJson('updateResource', obj).subscribe(
        (data) => {
          var response = JSON.parse(data.body);
          this.isLoading = false;

          console.log("this is response  update resource", response);
          this.sendNewResourceToParent(response.data[0])
          // this.metadataEvent.emit();
          this.createNotification('success', '', response['message']);

          this.hideDrawer.emit();
        },
        (error) => {
          console.log('error', error);
          this.isLoading = false;
          this.createNotification(
            'error',
            '',
            'An error occurred. Please try again later.'
          );
        }
      );
    }
    //In case of URL updated
    if (
      this.fileList === undefined &&
      (this.initialValues.resource_path === '' ||
        this.initialValues.resource_path === null)
    ) {
      if (!this.resourceForm.get('resource_url').valid) {
        this.isLoading = false;
        this.createNotification('error', '', 'Enter valid url');
        return;
      }
      this.finalUpdate();
    }
  }

  finalUpdate() {
    let obj = {
      resource_id: this.resourceId,
      ...this.resourceForm.value,
    };
    
    obj.target_index = obj.position;
    console.log("this is object", obj);
    
    if(!obj.target_index || obj.target_index < 1){
      throw new Error("Enter valid position!");
    }

    if (this.selectedRootFolder || this.initialValues.parent_folder) {
      obj.parent_folder = this.selectedRootFolder ? this.selectedRootFolder : this.initialValues.parent_folder;
    }
    else{
      obj.parent_folder = null;
    }
    

    console.log('this is obj in finalUpdate func()', obj);
    this.webapi.requestJson('updateResource', obj).subscribe(
      (data) => {
        let response = JSON.parse(data.body);
        this.isLoading = false;
        // this.metadataEvent.emit();
        console.log("this is response  update resource", response);
        this.sendNewResourceToParent(response.data[0])
        this.createNotification('success', '', response['message']);

        this.hideDrawer.emit();
      },
      (error) => {
        this.isLoading = false;
        this.createNotification(
          'error',
          '',
          'An error occurred. Please try again later.'
        );
      }
    );
  }

  resetResourceForm(): void {
    this.resourceForm.reset();
    this.updateMode = false;
    this.rawUpdateResource = {};
    this.fileList = undefined;
    // this.resourceForm.get('File').setValue(null);
  }

  resetUpdateForm(): void {
    this.fileList = undefined;
    const tagIds = this.rawUpdateResource.tag.map((tag) => tag.tag_id);
    this.resourceForm.patchValue({
      category_id: this.rawUpdateResource.category_id,
      document_notes: this.rawUpdateResource.document_notes,
    });
    this.resourceForm.controls.tag.setValue(tagIds);
  }

  // resourcePosition(newIndex) {

   
  //   console.log("this is newIndex",newIndex)
  //  console.log('this is filteredresources', this.filteredResourcess);

  //  if(this.isNormalization(this.filteredResourcess)){
  //   this.apiCountNormalization();
  // }

  // if(this.filteredResourcess.length === 0){
  //   let newPosition = 1000;
  //   return newPosition;
  // }
  
  //   // this.resourceForm.setValue({position: newIndex})
  //   if (this.updateMode) {
  //     if (newIndex === this.initialValues.index) {
  //       console.log("same value");
  //       return this.initialValues.position;
  //     } else {
  //       if (newIndex === 1) {
  //         const belowResourcePosition = this.filteredResourcess[0];

  //         let newPosition = this.positionCalculate(
  //           null,
  //           belowResourcePosition.position
  //         );
  //         console.log('this is newPosition for 1st index', newPosition);
  //         return newPosition;
  //       } else {
  //         if (!newIndex || newIndex < 1) {
  //           console.warn('Invalid index');
  //           return;
  //         }

  //         // Calculate new position value
  //         let newPos: number;
  //         if (newIndex === this.filteredResourcess.length) {
  //           // If moved to the last position
  //           newPos =
  //             this.filteredResourcess[this.filteredResourcess.length - 2]
  //               .position + 1000;
  //         } else if(newIndex > this.filteredResourcess.length){

  //           let lastPos = this.filteredResourcess[this.filteredResourcess.length - 1] ? this.filteredResourcess[this.filteredResourcess.length - 1].position : (this.filteredResourcess.length * 1000);
  //           // Position is between two items
  //          newPos =  lastPos + 1000;
            
  //         }else {
  //           // Position is between two items
  //           const prevPos =
  //             this.filteredResourcess[newIndex - 2]?.position || 0;
  //           const nextPos =
  //             this.filteredResourcess[newIndex]?.position || prevPos + 2000;
  //           newPos = (prevPos + nextPos) / 2;
  //         }
  //         console.log('newPos:', newPos);
  //         return newPos;
  //       }
  //     }
  //   } else {
  //     if (newIndex === 1) {
  //       const belowResourcePosition = this.filteredResourcess[0];

  //       let newPosition = this.positionCalculate(
  //         null,
  //         belowResourcePosition.position
  //       );
  //       console.log('this is newPosition for 1st index', newPosition);
  //       return newPosition;
  //     } else {
  //       if (!newIndex || newIndex < 1) {
  //         console.warn('Invalid index');
  //         return;
  //       }

  //       // Calculate new position value
  //       let newPos: number;
  //       if (newIndex === this.filteredResourcess.length) {
  //         // If moved to the last position
  //         newPos =
  //           this.filteredResourcess[this.filteredResourcess.length - 2]
  //             .position + 1000;
  //       }else if(newIndex > this.filteredResourcess.length){
  //          // If moved to the last position
  //         newPos = (this.filteredResourcess.length + 1) * 1000;

  //       } 
  //       else {
  //         // Position is between two items
  //         const prevPos =
  //           this.filteredResourcess[newIndex - 2]?.position || 0;
  //         const nextPos =
  //           this.filteredResourcess[newIndex]?.position || prevPos + 2000;
  //         newPos = (prevPos + nextPos) / 2;
  //       }

  //       console.log('newPos:', newPos);
  //       return newPos;
  //     }
  //   }


  // }


  // positionCalculate(aboveResource?: any, belowResource?: any): number {
  //   let newPosition: number;
  //   const abovePos = aboveResource || null; // Above adjacent item's position
  //   const belowPos = belowResource || null; // Below adjacent item's position

  //   console.log('Above Resource:', abovePos);
  //   console.log('Below Resource:', belowPos);

  //   if (abovePos === null && belowPos !== null) {
  //     // Case 1: Item is moved to the top
  //     newPosition = belowPos / 2;
  //     console.log('New Position (Top):', newPosition);
  //   } else if (belowPos === null && abovePos !== null) {
  //     // Case 2: Item is moved to the last position
  //     const resourceLength = this.filteredResourcess.length || 1; // Avoid multiplication by zero
  //     newPosition = (resourceLength + 1) * 1000;
  //     console.log('New Position (Bottom):', newPosition);
  //   } else if (abovePos !== null && belowPos !== null) {
  //     // Case 3: Item is moved between two elements
  //     newPosition = (abovePos + belowPos) / 2;
  //     console.log('New Position (Middle):', newPosition);
  //   } else {
  //     // Case 4: No references available (e.g., first item being added)
     
  //    newPosition = this.filteredResourcess.length > 0 ? this.filteredResourcess[0].position / 2 : 1000;
  //     console.log('New Position (Default):', newPosition);
  //   }

  //   return newPosition;
  // }

  // isNormalization(data): boolean{
  //   if (!data || data.length < 2) {
  //     return false;
  //   }
  
  //   for (let i = 0; i < data.length - 1; i++) {
  //     let temp = data[i + 1].position - data[i].position;
  //     if (temp <= 100) {
  //       return true;
  //     }
  //   }
  
  //   return false;
  // }
  // apiCountNormalization() {
  //   let obj = {
  //     parentFolderId : this.filteredResourcess[0].parent_folder
  //   }

  //   this.isLoading = true;
  //   this.webapi
  //     .requestJson('resourceNormalization',obj)
  //     .subscribe(
  //       (data) => {
  //         this.isLoading = false;
         
  //       },
  //       (error) => {
  //         this.isLoading = false;
          
  //         console.log('ERROR', error);
  //       }
  //     );
  // }
  
  clickSwitch(OldValue: boolean): void {
    const newValue = !OldValue;

    // Prevent immediate switch by reverting model
    setTimeout(() => (this.isShareable = OldValue));

    // Show confirmation modal
    this.modal.confirm({
      nzTitle: 'Confirm Shareability Change',
      nzContent: newValue // true + -negative => false ; false + -negative => true
        ? 'You are about to make this resource shareable. This means anyone with access can view or download it. Do you want to proceed?'
        : 'You are about to disable sharing for this resource. It will no longer be accessible to others. Do you want to proceed?',
      nzOkText: 'Yes',
      nzCentered: true,
      nzCancelText: 'No',
      nzOnOk: () => {
        this.isShareable = !OldValue;
        console.log('this is isShareable', this.isShareable);
        this.resourceForm.get('is_shareable').setValue(this.isShareable);
        this.resourceForm.markAsDirty();
      }
    });
  


  }

  
}
